import InteractiveLayer from './InteractiveLayer/InteractiveLayer'

export default class InfoLayer {
    element: SVGSVGElement
    id: string

    constructor(id: string, infoLayerSvg: SVGSVGElement) {
        this.id = id
        this.element = infoLayerSvg
    }

    // TODO for demo use the old code that constructs the svg at run time
    static fromInteractiveLayer = (id: string, interactiveLayer: InteractiveLayer) => {
        const infoLayer = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        const svgNS = infoLayer.namespaceURI

        for (const attr in interactiveLayer.element.attributes) {
            const attribute = interactiveLayer.element.attributes[attr]
            infoLayer.setAttribute(attribute.name, attribute.value)
        }

        infoLayer.setAttribute('id', 'info-layer')

        const defs = document.createElementNS(svgNS, 'defs')
        const radGradient = document.createElementNS(svgNS, 'radialGradient')
        radGradient.setAttribute('id', 'radial-gradient')

        const start = document.createElementNS(svgNS, 'stop')
        const stop = document.createElementNS(svgNS, 'stop')

        start.setAttribute('offset', '0%')
        start.setAttribute('stop-color', 'rgba(250, 250, 85, .8)')

        stop.setAttribute('offset', '100%')
        stop.setAttribute('stop-color', 'rgba(250, 250, 85, 0)')

        radGradient.appendChild(start)
        radGradient.appendChild(stop)

        defs.appendChild(radGradient)

        infoLayer.appendChild(defs)

        const polygons = interactiveLayer.element.children

        ;[].forEach.call(polygons, function (polygon: SVGPolygonElement) {
            const x: Array<number> = []
            const y: Array<number> = []

            ;[].forEach.call(polygon.points, function (point: DOMPoint) {
                x.push(point.x)
                y.push(point.y)
            })

            const avX =
                x.length <= 0
                    ? -1000
                    : x.reduce(function (lastX, thisX) {
                          return lastX + thisX
                      }) / x.length

            const avY =
                y.length <= 0
                    ? -1000
                    : y.reduce(function (lastY, thisY) {
                          return lastY + thisY
                      }) / y.length

            const circle = document.createElementNS(svgNS, 'circle')
            circle.setAttribute('id', polygon.id + '-info-circle')
            circle.setAttribute('cx', Math.floor(avX).toString())
            circle.setAttribute('cy', Math.floor(avY).toString())
            circle.setAttribute('r', '42')
            circle.setAttribute('fill', 'url(#radial-gradient)')

            infoLayer.appendChild(circle)
        })
        return new InfoLayer(id, infoLayer)
    }

    remove = () => {
        this.element.remove()
    }

    getHotspotElement = (interactableObjectId: string) => this.element.querySelector(`#${interactableObjectId}`)

    removeHotspot = (interactableObjectId: string) => {
        this.getHotspotElement(interactableObjectId + '-info-circle')?.remove()
    }

    hideHotspot = (interactableObjectId: string) => {
        this.getHotspotElement(interactableObjectId + '-info-circle')?.classList.add('hidden')
    }

    showHotspot = (interactableObjectId: string) => {
        this.getHotspotElement(interactableObjectId + '-info-circle')?.classList.remove('hidden')
    }
}
